import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { MaintenanceMessages } from "./MaintenanceMessage";
import { Notifications } from "./Notifications";
import { withIntlRoot } from "../IntlRootMixin";
import LogoutPopupWrapper from "./LogoutPopupWrapper";
import ErrorPage from "./ErrorPage";
import CountryUtil from "../uidispatcherapi/CountryUtil";
import { ForceReloadStore } from "../stores/ForceReloadStore";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import BrowserSupportPopup from "./BrowserSupportPopup";
import FooterActions from "../actions/FooterActions";
import HeaderActions from "../actions/HeaderActions";
import { wrapLazily } from "../lazy-loading/lazyWrapper";
import history from "../uidispatcherapi/BettyHistoryModule";
import PageHeader from "./PageHeader";
import { PageBottom } from "./PageBottom";
import { Modal, ModalContent } from "@metro-ui/core";

const HeaderEmployee = wrapLazily(() => import("explore_ui/HeaderEmployee"), {
	usesBootstrap: true,
	usesMoment: false,
});
const forceReloadStore = new ForceReloadStore();
forceReloadStore.checkForForceReload().catch(error => console.error(error));

type AppProps = {
	history: any;
	location: any;
	children: React.ReactNode;
};
type AppState = {
	displayForceReloadNotification: boolean;
	errorOccurred: boolean;
	error: Record<string, any>;
	errorInfo: Record<string, any>;
};

class AppComponent extends React.Component<AppProps, AppState> {
	static readonly contextTypes = {
		router: PropTypes.object,
	};
	static readonly childContextTypes = {
		location: PropTypes.object,
		history: PropTypes.object,
	};

	constructor(props: AppProps) {
		super(props);
		this.state = {
			displayForceReloadNotification: forceReloadStore.isReloadPending(),
			errorOccurred: false,
			error: {},
			errorInfo: {},
		};
	}

	getChildContext() {
		return {
			location: this.props.location,
			history: this.props.history,
		};
	}

	componentDidCatch(error, errorInfo) {
		console.error(error, errorInfo);
		this.setState({
			errorOccurred: true,
			errorInfo: errorInfo,
			error: error,
		});
	}

	componentDidMount() {
		const root = document.getElementsByTagName("html")[0];
		const country = SessionStore.getCountry();

		if (country) {
			root.classList.add("co-" + country.toLowerCase());
		}

		const locale = SessionStore.getLocale();

		if (locale) {
			root.classList.add("lo-" + locale.toLowerCase());
		}

		forceReloadStore.listen(() =>
			this.setState({
				displayForceReloadNotification: forceReloadStore.isReloadPending(),
			}),
		);
	}

	componentDidUpdate() {
		FooterActions.updateFooter();
		HeaderActions.updateHeader();
	}

	renderOldFooter() {
		if (FeatureSessionStore.getMembershipFor("ENABLE_NEXTCMS_FOOTER") !== "B") {
			const Footer = wrapLazily(() => import("cia_ui/Footer"), {
				usesBootstrap: true,
				usesMoment: true,
			});
			return <Footer useLegacyFooter location={this.props.location} />;
		}

		return null;
	}

	renderOldCookieDisclaimer() {
		if (FeatureSessionStore.getMembershipFor("ENABLE_NEXTCMS_COOKIE_DISCLAIMER") !== "B") {
			const CookieLawDisclaimer = wrapLazily(() => import("cia_ui/CookieLawDisclaimer"), {
				usesBootstrap: true,
				usesMoment: true,
			});
			return <CookieLawDisclaimer />;
		}

		return null;
	}

	renderApp() {
		if (this.state.errorOccurred) {
			return <ErrorPage error={this.state.error} errorInfo={this.state.errorInfo} />;
		}

		const header = <div>{HeaderEmployee ? <HeaderEmployee /> : <div />}</div>;
		const sessionId = SessionStore.getClientSessionId();

		if (SessionStore.pending()) {
			// not rendering because still pending (TODO(EP) could do without?)
			return (
				<div className="loading-message">
					<FormattedMessage id="PL_LOADING" />
				</div>
			);
		}

		return (
			<div>
				{header}
				<div className="hidden test-session-id" title={sessionId} />
				<Notifications />
				<Modal isOpen={this.state.displayForceReloadNotification} zIndex={1050} padding="medium">
					<ModalContent>
						<FormattedMessage id="PL_FORCE_RELOAD_PENDING" />
					</ModalContent>
				</Modal>
				{this.props.children}
				{this.renderOldFooter()}
				{this.renderOldCookieDisclaimer()}
				<LogoutPopupWrapper />
				<MaintenanceMessages maintenance_messages={CountryUtil.getOptionalConfig().maintenance_messages} />
				<BrowserSupportPopup />
			</div>
		);
	}

	render() {
		return (
			<>
				<PageHeader history={history.get()} />
				{this.renderApp()}
				<PageBottom />
			</>
		);
	}
}

export const App = withIntlRoot(AppComponent);
